import ProductTypesStore from '@shared/svelte/Stores/ProductTypesStore.js';

var service = function(CachedRequest, APP, SharedReactContext) {
  var cachedRes;
  var cachedResDropdown;
  var setData = function(data) {
    cachedResDropdown = data;
    cachedRes = {};
    _.map(data.types, function(i) {
      cachedRes[i.id] = i;
    });

    SharedReactContext.set('productTypes', cachedRes);
    SharedReactContext.set('productPackagingDescriptions', data.product_packaging_descriptions);
    SharedReactContext.set('productContainerTypes', data.container_types);
  }
  return {
    get: function() {
      return cachedRes;
    },
    getDropdown: function() {
      return cachedResDropdown;
    },
    set: function(data) {
      setData(data);
    },
    load: function() {
      return CachedRequest({
        method: 'GET',
        url: '/api/' + APP + '/product_types'
      }).then(function(res) {
        setData(res.data);
        ProductTypesStore.update(n => res.data);
        return cachedRes;
      });
    },
    loadAll: function () {
      return CachedRequest({
        method: 'GET',
        url: '/api/' + APP + '/product_types'
      }).then(function(res) {
        setData(res.data);
        ProductTypesStore.update(n => res.data);
        return cachedResDropdown;
      });
    }
  };
};

service.$inject = ['CachedRequest', 'APP', 'SharedReactContext'];
tiz.service('ProductTypes', service);
